import React, { ReactNode, useState } from "react";
import { IMusic } from "../../commonTypes";
import ButtonOutlined from "../Buttons/ButtonOutlined";
import { routes } from "../../../routes";
import ShareModal from "../Modal/ShareModal";
import { useTranslation } from "react-i18next";
import { safe } from "../../../helpers/safeWebApis";

interface IRenderProps {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

interface IProps {
  music: IMusic;
  listingId?: string;
  children?: (renderProps: IRenderProps) => ReactNode;
  className?: string;
}

const ShareBidButton = ({ music, listingId, children, className }: IProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      {children ? (
        children({ isOpen, open, close })
      ) : (
        <ButtonOutlined
          text={t("share")}
          onClick={open}
          height="48px"
          fullWidth
          className={className}
        />
      )}
      <ShareModal
        isOpen={isOpen}
        onClose={close}
        url={`${safe.window?.location.origin}${routes.marketplace.id(
          music.id,
          listingId
        )}`}
        image={music?.cover}
      />
    </>
  );
};

export default ShareBidButton;
